export default __webpack_public_path__ + "static/media/Commander's Legguards of the Eastern Sun.7390874b.jpg";